import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import { Container } from '@/components/generals/container'

import { contactHref } from '@/constants/site'

interface CtaBandProps {
    title?: string
    description?: string
    buttonLabel?: string
}

export const CtaBand: FC<CtaBandProps> = ({
    title = "Da li ste spremni za sljedeći projekat?",
    description = "Kontaktirajte nas za besplatne konsultacije i procjenu Vaših radova.",
    buttonLabel = "Kontaktirajte nas"
}): ReactNode => {
    return (
        <section id='spremni' aria-labelledby='spremni-title' className='relative isolate overflow-hidden bg-ink text-white'>
            <div
                aria-hidden='true'
                className='blueprint-grid absolute inset-0 -z-10 text-white [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]'
            />

            <Container className='flex flex-col items-center py-16 text-center lg:py-20'>
                <h2 id='spremni-title' className='max-w-3xl text-3xl font-bold tracking-tight sm:text-4xl lg:text-[2.6rem]'>
                    {title}
                </h2>

                <p className='mt-4 max-w-2xl text-base leading-relaxed text-ink-muted sm:text-lg'>
                    {description}
                </p>

                <Link href={contactHref} className={buttonVariants({ variant: 'ghostLight', size: 'xl', className: 'mt-8' })}>
                    {buttonLabel}
                    <ArrowRight data-icon='inline-end' aria-hidden='true' />
                </Link>
            </Container>
        </section>
    )
}
